import { useState, useEffect } from "react"
import getUrl from "../../tools/get-domain"
import MarketTable from "../../components/MarketTable"
import { config } from "./justify_process_data"
import Paginate from "../../components/Paginate"

function JustifyPage() {
    const [symbols, setSymbols] = useState([])
    const [currentPage, setCurrentPage] = useState(1);
    const dataPerPage = 10

    const indexOfLastData = currentPage * dataPerPage < symbols.length ? currentPage * dataPerPage : symbols.length;
    const indexOfFirstData = (currentPage * dataPerPage) - dataPerPage;
    const currentSymbols = symbols.slice(indexOfFirstData, indexOfLastData);

    const fetchData = async () => {
        const response = await fetch(getUrl().REACT_APP_JUSTIFY)
        let data = await response.json()
        data = data.sort((a, b) => (a.date < b.date) ? 1 : ((b.date < a.date) ? -1 : 0))
        setSymbols(data)
    }

    const paginate = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const previousPage = () => {
        if (currentPage !== 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const nextPage = () => {
        if (currentPage !== Math.ceil(symbols.length / dataPerPage)) {
            setCurrentPage(currentPage + 1);
        }
    }

    useEffect(() => {
        fetchData()
        const invterval = setInterval(() => fetchData(), 60000 * 32)
        return () => clearInterval(invterval)
    }, [])

    return (
        <div>
            <div className="content flex-row-fluid" id="kt_content" dir="rtl">
                <div className="container-fluid mt-lg-0 mt-5">
                    <div className="row">
                        <div className="col-xl-12 d-block">
                            <div className=" h-100">
                                <MarketTable config={config} rows={currentSymbols} date={null} theme='table-striped' />
                                <Paginate
                                    dataPerPage={dataPerPage}
                                    totalData={symbols.length}
                                    paginate={paginate}
                                    previousPage={previousPage}
                                    nextPage={nextPage}
                                    currentPage={currentPage}
                                />

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default JustifyPage